import { Company, DateType, User } from 'api/models';
import { ProgressStatus, Project, ProjectPhase } from 'api/project';
import { FieldValue, FieldValueType, StatusFieldOption, Task } from 'api/tasks';
import { Filter } from 'components/molecules/filters/types';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { SprintType } from 'components/organisms/sprint-planning/types';

export enum SprintPoints {
  Linear = 'LINEAR',
  Fibonacci = 'FIBONACCI',
  Exponential = 'EXPONENTIAL',
  Custom = 'CUSTOM',
}

export interface SprintConfig {
  pointType: SprintPoints;
  pointValue: number;
  statusesToShow: number[];
  pointsEnabled: boolean;
}

export interface PaginatedSprintParams {
  startRow: number;
  endRow: number;
  filter: Filter;
  sort?: string;
  search?: string;
  range: DateRange | null;
}

export interface Sprint {
  sprintName: string;
  sprintId: number;
  accountId: number;
  startDate: DateType;
  dueDate: DateType;
  duration: number;
  tasksInSprint: number;
  sprintOwner: Partial<User>;
  tasksCompleted?: number;
  taskProgress: ProgressStatus[];
  pointProgress: ProgressStatus[];
  fields: FieldValue<FieldValueType>[];
  totalPoints: number;
  actualStartDate: DateType;
  actualDueDate: DateType;
  associatedProjects: number[];
  projectPhase: Pick<ProjectPhase, 'projectPhaseId' | 'projectPhaseName'>;
  projects: (Pick<Project, 'projectId' | 'projectName'> & {
    companyLogoUrl?: string;
  })[];
  sprintType: SprintType;
  sprintCollaborators: number[];
  private: boolean;
  sprintSquad?: User[];
  effortInMinutes?: number;
  trackedMinutes?: number;
  completedAt?: number | null;
  responsible: Company[];
}

export interface PaginatedSprintResponse {
  data: Sprint[];
  count: number;
}

export enum SprintStatus {
  Todo = 1,
  InProgress = 2,
  Completed = 3,
}

export type CreateSprintResponse = {
  sprintId: number;
};

export interface GetSprintListPayload {
  startDate: DateType;
  endDate: DateType;
  isAlreadyAddedToPhase: boolean;
  projectIds?: number;
  inComplete?: boolean;
  sprintId?: number;
}

export type TasksInSprintForExternalUser = {
  data: {
    status: StatusFieldOption;
    tasks: Task[];
  }[];
  totalTasks: number;
};

export type SprintsListItem = Pick<
  Sprint,
  'sprintId' | 'sprintName' | 'sprintOwner' | 'startDate' | 'dueDate' | 'fields'
> & {
  countOfTasksNotAddedInSprint: number;
  tasksInSprint: number;
};

export type SprintsList = SprintsListItem[];
